<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		:style="getMainWrapperStyle(node)"
		@click="onNodeClick(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<div class="divider-wrapper" :style="getWidthStyle(node)">
			<div :class="node.class" :style="getStyle(node)"/>
		</div>
	</div>
</template>

<script>
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
import {
	getRgbaColor,
	getNodeStyle,
	// eslint-disable-next-line
} from '@/lib/helper';

export default {
	name: 'NodeDivider',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
	},
	methods: {
		getWidthStyle({ options }) {
			const { width, widthUnit } = options;
			const style = {};
			const fixedWidthUnit = widthUnit && widthUnit !== '' ? widthUnit : 'px';
			style.width = width && width !== ''
				? `${width}${fixedWidthUnit}`
				: '100%';
			return style;
		},
		getStyle({ options }) {
			const style = {};

			if (options) {
				const {
					size,
					sizeUnit,
					color,
				} = options;

				style['border-style'] = options.style || 'solid';

				style['border-color'] = color && color.rgb && color.rgb !== ''
					? getRgbaColor(color.rgb)
					: color;

				const fixedSizeUnit = sizeUnit && sizeUnit !== '' ? sizeUnit : 'px';
				style['border-top-width'] = size && size !== ''
					? `${size}${fixedSizeUnit}`
					: '1px';
			}

			return style;
		},
		getMainWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
				'padding',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},
	},
};
</script>

<style scoped></style>
